import { ComponentPropsWithoutRef, ReactNode } from "react"
import { useDisableTabbingDuringAnimation } from "shared/hooks/useDisableTabbing"

export type SheetProps = ComponentPropsWithoutRef<"div"> & {
  open: boolean
  title?: string
  description?: string
  topLeftContent?: ReactNode
  topRightContent?: ReactNode
}

export const Sheet = ({
  className,
  open,
  title,
  description,
  topLeftContent,
  topRightContent,
  children,
  ...props
}: SheetProps) => {
  useDisableTabbingDuringAnimation(open, 450) // NOTE: This duration must match the animation duration in Sheet.css
  return (
    <div className="sheet-backdrop" data-open={open}>
      <div className={`sheet ${className}`} data-open={open} {...props}>
        {(title || description || topLeftContent || topRightContent) && (
          <div className="sheet-header">
            <div className="sheet-top-left-content">{topLeftContent}</div>
            {(title || description) && (
              <div className="sheet-title-section">
                {title && (
                  <h2 className="sheet-title title-lg text-color-primary">
                    {title}
                  </h2>
                )}
                {description && (
                  <p className="sheet-description body-md text-color-secondary-subdued">
                    {description}
                  </p>
                )}
              </div>
            )}
            <div className="sheet-top-right-content">
              {topRightContent}
            </div>
          </div>
        )}
        {children}
      </div>
    </div>
  )
}
